import { Tr, Td, Text, Tooltip } from '@chakra-ui/react'
import { FC } from 'react'
import Highlighter from 'react-highlight-words'

import useProfile from '@hook/shared/use-profile'

interface IProfilesModalTableTrProps {
  data: { [key: string]: any }
  onSelect: (data: any) => void
  onUpdate: () => void
}

const ProfilesModalTableTr: FC<IProfilesModalTableTrProps> = ({ data }) => {
  const { profileQuery: fastQuery } = useProfile()
  return (
    <Tr>
      <Td>
        {fastQuery.length > 0 ? (
          <Text maxW="220px" isTruncated>
            <Highlighter
              searchWords={fastQuery.split(' ')}
              textToHighlight={String(data.nome || 'Não informado')}
            />
          </Text>
        ) : (
          <Text maxW="200px" isTruncated>
            {data.nome || 'Não informado'}
          </Text>
        )}
      </Td>
      <Td>
        <Tooltip
          label={data.descricao || 'Não cadastrado'}
          placement="auto-start"
        >
          {fastQuery.length > 0 ? (
            <Text maxW="220px" isTruncated>
              <Highlighter
                searchWords={fastQuery.split(' ')}
                textToHighlight={String(data.descricao || 'Não informado')}
              />
            </Text>
          ) : (
            <Text maxW="220px" isTruncated>
              {data.descricao || 'Não cadastrado'}
            </Text>
          )}
        </Tooltip>
      </Td>
      <Td>
        <Tooltip
          label={data.descricao || 'Não cadastrado'}
          placement="auto-start"
        >
          {fastQuery.length > 0 ? (
            <Text maxW="220px" isTruncated>
              <Highlighter
                searchWords={fastQuery.split(' ')}
                textToHighlight={String(data.acesso || 'Não informado')}
              />
            </Text>
          ) : (
            <Text maxW="220px" isTruncated>
              {data.acesso || 'Não cadastrado'}
            </Text>
          )}
        </Tooltip>
      </Td>
    </Tr>
  )
}

export default ProfilesModalTableTr
